angular.module('gym').factory('AllForms', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var gymId;
  gymId = $rootScope.toParams.gymId;
  return Restangular.one('gyms', gymId).all('forms').all('all_forms.json');
}]);
